import React, { useState } from 'react';
import { useCachedFile } from '~/hooks/useCachedFile';

export default function CacheTest() {
    const [testUrl] = useState('https://apollo-media-production.s3.us-east-1.amazonaws.com/test/teste.png');
    const { cachedUrl, loading, error } = useCachedFile(testUrl);

    // Só mostra em desenvolvimento
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            background: 'rgba(0,0,0,0.9)',
            color: 'white',
            padding: '20px',
            borderRadius: '10px',
            zIndex: 10000,
            maxWidth: '300px'
        }}>
            <h3>🧪 Cache Test</h3>
            <div>
                <strong>URL:</strong> {testUrl}
            </div>
            <div>
                <strong>Status:</strong> {loading ? '⏳ Carregando...' : error ? '❌ Erro' : '✅ Pronto'}
            </div>
            <div>
                <strong>Cache URL:</strong> {cachedUrl ? '✅ Sim' : '❌ Não'}
            </div>
            {error && (
                <div style={{ color: 'red' }}>
                    <strong>Erro:</strong> {error.message}
                </div>
            )}
            {cachedUrl && (
                <div>
                    <img src={cachedUrl} alt="Test" style={{ width: '100px', height: 'auto' }} />
                </div>
            )}
        </div>
    );
}
